import * as C from '../common/constants';
import MenuBox from './MenuBox';
import clsx from 'clsx';
import { EMenus } from '../common/enums';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { storeData, clearData } from '../common/app/actions';
import { useSelector, useDispatch } from 'react-redux';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { getPath } from '../common/utils/helpers';

const urlPrefix = getPath();

const useStyles = makeStyles(
  (theme: any): StyleRules =>
    createStyles({
      schemeStyle: {
        position: 'relative',
        width: '100%',
        // height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '50px',
      },
      wrapperStyle: {
        display: 'flex',
        width: '100%',
        minHeight: '56px',
        minWidth: '160px',
        boxSizing: 'border-box',
        // padding: '14px',
        flexWrap: 'wrap',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        gap: '12px',
      },
      titleStyle: {
        width: '100%',
        fontFamily: theme.typography.fontFamily,
        // fontWeight: 400,
        fontSize: '16px',
        color: `${COLORS.white} !important`,
        textAlign: 'center',
        paddingBottom: '20px',
        fontWeight: FONT_WEIGHT.bold,
      },
      iconBoxStyle: {
        width: '124px',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            filter: 'brightness(120%)',
            transition: '0.5s ease',
          },
        },
      },
      iconStyle: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        // borderRadius: '4px',
        width: '124px',
        height: '80px',
        // overflow: 'hidden',
        paddingBottom: '6px',
      },
      nameStyle: {
        position: 'absolute',
        fontFamily: theme.typography.fontFamily,
        fontWeight: 400,
        fontSize: '12px',
        color: `${COLORS.white} !important`,
        textTransform: 'uppercase',
        bottom: '8px',
      },
      imgStyle: {
        // width: '100%',
        // height: 'auto',
        // borderRadius: '4px',
        // background: 'white',
        width: '101px',
        height: '70px',
      },
      selectedStyle: {
        outline: `2px solid ${COLORS.red}`,
      },
      unSelectedStyle: {
        opacity: 0.3,
      },
      '@media only screen and (max-height: 740px)': {
        schemeStyle: {
          marginBottom: '30px',
        },
      },
      '@media only screen and (max-height: 640px)': {
        schemeStyle: {
          marginBottom: '20px',
        },
        nameStyle: {
          fontSize: '10px',
        },
        iconStyle: {
          height: '60px',
          paddingBottom: '4px',
        },
        imgStyle: {
          width: '86px',
          height: '60px',
        },
      },
      '@media only screen and (max-height: 540px)': {
        titleStyle: {
          fontSize: '14px',
          paddingBottom: '10px',
        },
        iconStyle: {
          paddingBottom: '10px',
        },
        imgStyle: {
          width: '72px',
          height: '50px',
        },
      },
    })
);

const SelectPaintScheme = (): JSX.Element => {
  const classes = useStyles();
  const dispatch: any = useDispatch();

  const currentPaintData = useSelector((state: any) => state.app[C.SET_PAINT]);

  const appData = useSelector((state: any) => state.app[C.APP_DATA]);
  const paintData = appData[EMenus.PAINT];
  const labels = appData.labels;

  const onClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();

    const id = event.currentTarget.getAttribute('data-id');
    const currentData = paintData.find((item) => item.name === id);

    dispatch(storeData(currentData, C.SET_PAINT));
    dispatch(storeData(currentData.colors, C.SET_COLORS));
    dispatch(clearData(C.SET_WINGLIGHT));

    // const firstVisibleColorIndex = currentData.colors.findIndex(
    //   (item) => item.visible
    // );
    // const firstColor = currentData.colors[firstVisibleColorIndex]?.default;
    // dispatch(
    //   storeData(
    //     { nr: firstVisibleColorIndex + 1, color: firstColor },
    //     C.SET_SELECTED_COLOR
    //   )
    // );
  };

  const getIcons = (item, index) => {
    // const url = `.assets/paints/${item.icon}`;
    const url = `${urlPrefix}/${item.icon}`;
    const paintName = item.name;
    const isSelected = currentPaintData?.name === paintName;
    const isUnselected = currentPaintData && !isSelected;

    return (
      <div
        key={index}
        className={classes.iconBoxStyle}
        onClick={onClick}
        data-id={paintName}
      >
        <div
          className={clsx(
            classes.iconStyle,
            isSelected && classes.selectedStyle
          )}
        >
          <img
            src={url}
            alt={paintName}
            // crossOrigin="anonymous"
            className={clsx(
              classes.imgStyle
              // isUnselected && classes.unSelectedStyle,
              // isSelected && classes.selectedStyle
            )}
          />
          <div className={classes.nameStyle}>{paintName}</div>
        </div>
      </div>
    );
  };

  return (
    <div className={classes.schemeStyle}>
      {/* <MenuBox title={title} /> */}
      <div className={classes.titleStyle}>{labels?.paintSchemeLabel}</div>
      <div className={classes.wrapperStyle}>{paintData.map(getIcons)}</div>
    </div>
  );
};

export default SelectPaintScheme;
